import { type CSSProperties } from "react";
import { type HighlightRect } from "@/lib/findInText";

/** Translucent highlight rectangles over each search match — a "highlighter marker"
 * layer that sits above the text (pointer-events: none, so click-to-edit still
 * works) and tints it without hiding it. The current match gets a stronger amber.
 * Rendered inside the memo content column (its positioned ancestor). */
export function MemoFindHighlights({
  rects,
  current,
}: {
  rects: HighlightRect[];
  current: number;
}) {
  return (
    <div aria-hidden style={overlayStyle}>
      {rects.map((r, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            top: r.top,
            left: r.left,
            width: r.width,
            height: r.height,
            borderRadius: 2,
            background:
              r.matchIndex === current ? "rgba(246, 168, 33, 0.62)" : "rgba(250, 204, 21, 0.42)",
          }}
        />
      ))}
    </div>
  );
}

const overlayStyle: CSSProperties = {
  position: "absolute",
  inset: 0,
  pointerEvents: "none",
  zIndex: 3,
};
